import { baseUrl } from '@fs/zion-config'
// The server reads the JSON file too. Key order sets the match order.
import environments from './environments.json'

export type EnvironmentKey = 'prod' | keyof typeof environments

/** Picks the environment from the zion-config base URL. */
export function getEnvironmentKey(): EnvironmentKey {
  const keys = Object.keys(environments) as (keyof typeof environments)[]
  return keys.find((key) => baseUrl.includes(environments[key])) ?? 'prod'
}
